<template>
    <DefaultTemplate :model="model">
        <div class="container">
            <div class="mt-12 mb-8">
                <Breadcrumbs :breadcrumbs="model.breadcrumbs" className="text-grey-400" />
            </div>

            <div class="block lg:flex">
                <div class="w-full lg:w-3/4 pr-0 lg:pr-4">
                    <div v-if="model.fagfellevurdert || model.redaksjonsomtale || model.forsideKategori" class="flex flex-wrap space-x-2 justify-end lg:hidden mb-6 text-right">
                        <span v-if="model.forsideKategori" class="text-xs font-bold tracking-wider p-1 text-white rounded-sm" :class="[categoryColor ? `bg-${categoryColor}-600` : 'bg-green-600']">
                            {{ model.forsideKategori }}
                        </span>
                        <span v-if="model.redaksjonsomtale" class="text-xs font-bold tracking-wider bg-gray-500 p-1 text-white rounded-sm">
                            Tilrettelagt av redaksjonen
                        </span>
                        <span class="text-xs font-bold tracking-wider p-1 text-white rounded-sm" :class="[categoryColor ? `bg-${categoryColor}-600` : 'bg-green-600']">
                            Fagfellevurdert artikkel
                        </span>
                    </div>
                    <div v-if="(model.images && model.images.length > 0) || inEditMode">
                        <ImageSlider :images="model.images" :params="imageParams" :transparent='true'/>
                    </div>
                    <article
                        :class="[categoryColor ? `border-${categoryColor}-500` : 'border-white']"
                        class="p-4 lg:py-10 mb-4"
                    >
                        <h1
                            v-if="model.heading || inEditMode"
                            v-epi-edit="'Heading'"
                            class="mb-2"
                        >
                            {{ model.heading }}
                        </h1>
                        <h1
                            v-else
                            v-epi-edit="'Name'"
                            class="mb-2"
                        >
                            {{ model.name }}
                        </h1>

                        <div v-epi-edit="'Intro'" class="main-body article" v-html="this.model.intro" />
                        <div v-epi-edit="'MainBody'" id="main-body" class="main-body article" v-html="this.model.mainBody" />
                        <ContentArea v-epi-edit="'MainContent'" :model="model.mainContent" />
                        <div v-epi-edit="'SecondaryBody'" id="seconday-body" class="main-body my-4 article" v-html="this.model.secondaryBody" />
                    </article>
                </div>
                <aside class="w-full lg:w-1/4 pr-0 lg:pl-4 mb-4">

                    <ContentArea v-epi-edit="'RightColumnContent'" :model="model.rightColumnContent" :pageId="model.contentLink.id" />

                    <article-box v-if="resources.length > 0 || inEditMode" :header='resourcesTitle' :colorTheme="categoryColor">
                        <dl>
                            <dd v-for="item in resources" :key="item.title" class="pt-2">
                                <div class="text-grey-400 hover:text-green-500">
                                    <a :href="item.url" :target="item.target" :title="item.text">
                                        <div class="flex flex-row">
                                            <div class="flex-1 text-black hover:text-green-500 underline truncate mr-2">
                                                {{item.text}}
                                            </div>
                                            <font-awesome-icon style="margin-top: 6px;" icon="file-alt" />
                                        </div>
                                    </a>
                                </div>
                            </dd>
                        </dl>
                        <a v-if="model.loginReturnUrl && model.loginButtonText"
                           :href="model.loginReturnUrl"
                           class="btn btn-green btn-xs justify-center mt-6">
                            {{ model.loginButtonText }}
                        </a>
                    </article-box>

                    <article-box v-if="model.rightColumnContent2 || inEditMode" :header="model.rightColumnContentHeader">
                        <ContentArea v-epi-edit="'RightColumnContent2'" :model="model.rightColumnContent2" />
                    </article-box>

                </aside>
            </div>
        </div>
    </DefaultTemplate>
</template>

<script>
import Breadcrumbs from '@/Scripts/components/organisms/Breadcrumbs/breadcrumbs.vue';
import ContentArea from '@/Scripts/components/ContentArea.vue';
import EpiProperty from '@/Scripts/components/EpiProperty.vue';
import Sharing from '@/Scripts/components/atoms/Sharing/Sharing.vue';
import ImageSlider from '@/Scripts/components/atoms/ImageSlider/ImageSlider.vue';
import ArticleBox from '@/Scripts/components/atoms/ArticleBox/ArticleBox.vue';
import { mapState } from 'vuex';

export default {
    props: ['model'],
    components: {
        Breadcrumbs,
        ContentArea,
        EpiProperty,
        Sharing,
        ArticleBox,
        ImageSlider
    },
    computed: mapState({
        inEditMode: state => state.epiContext.inEditMode
    }),
    data() {
        const { kategori } = this.model;
        return {
            categoryColor: (kategori && kategori.color ? kategori.color : null),
            dateOptions: { year: 'numeric', month: '2-digit', day: '2-digit' },
            authorImage: this.model.imageTopRight ? this.model.imageTopRight + '?scale=both&width=320&mode=pad&anchor=middleleft' : null,
            author: this.model.metaAuthor ? this.model.metaAuthor : 'Redaksjonen',

            artikkelReferanse: this.model.artikkelReferanse ? this.model.artikkelReferanse : false,
            articleRef: this.model.artikkelReferanseTitle ? this.model.artikkelReferanseTitle : 'Artikkelreferanser',

            internalPages: this.model.internalPages ? this.model.internalPages : [],
            internalPagesTitle: this.model.internalPagesTitle ? this.model.internalPagesTitle : 'Interne lenker',

            externalPages: this.model.externalPages ? this.model.externalPages : [],
            externalPagesTitle: this.model.externalPagesTitle ? this.model.externalPagesTitle : 'Eksterne lenker',

            documents: this.model.documents ? this.model.documents : [],
            documentsTitle: this.model.documentsTitle ? this.model.documentsTitle : 'Dokumenter',

            resources: this.model.resources ? this.model.resources : [],
            resourcesTitle: this.model.resourcesTitle ? this.model.resourcesTitle : 'Mer informasjon',

            imageParams: this.model.imageResizerParams ? 'scale=both&width=1112&maxheight=500&' + this.model.imageResizerParams : 'scale=both&width=1112&maxheight=500&'
        };
    },
    methods: {
        mapIcon(type) {
            switch (type) {
                case 'pdf':
                    return 'file-pdf';
                default:
                    return 'file-alt';
            }
        }
    }
};
</script>
